import * as React from 'react';

export function usePeekCalloutState(onCalloutDismiss?: () => void) {
    const [peekTarget, setPeekTarget] = React.useState<HTMLElement | undefined>(undefined);
    const [selectedItemId, setSelectedItemId] = React.useState<string | undefined>(undefined);
    const onClickCalendarEvent = React.useCallback((id: string, target?: HTMLElement) => {
        setPeekTarget(target);
        setSelectedItemId(id);
    }, []);

    const onEventsPeekCalloutDismissed = React.useCallback(() => {
        setPeekTarget(undefined);
        setSelectedItemId(undefined);
        onCalloutDismiss?.();
    }, [onCalloutDismiss]);

    return {
        selectedItemId,
        peekTarget,
        setPeekTarget,
        onClickCalendarEvent,
        onEventsPeekCalloutDismissed,
    };
}
